import script from "./ClientSecondary.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientSecondary.vue?vue&type=script&setup=true&lang=ts"

import "./ClientSecondary.vue?vue&type=style&index=0&id=60fb8ad0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60fb8ad0"]])

export default __exports__